'use strict';

function Search() {
    /********************************/
    // Init search
    /********************************/
    this.initSearch = function () {
        /*$('#SCL_SEARCH').autocomplete({
            source: '/ws/schools',
            minLength: 3,
            select: function (event, ui) {
                $('#ANSWER\\.TTQ\\.MENSYS\\.2\\.').val(ui.item.value);
                $(this).val('');
                return false;
            }
        });*/
    };
}